let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9S62V")).then(() => parcelRequire('dn2cU'));